import { Anchor, Breadcrumbs } from '@mantine/core';
import queryString from 'query-string';
import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import GoogleAdNewForm from '../../components/Google/Ads/GoogleAdNewForm';
import Metadata from '../../components/Metadata';
import GuidanceModal from '../../components/UserFlows/guidanceModal';
import { Page } from '../../constants/pageTitles';

const page = `${Page['googleAds']}`;

const GoogleAdsNewPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [guidanceShow, setGuidanceShow] = useState(false);
  const [googleAd, setGoogleAd] = useState();

  const { from } = queryString.parse(location.search);
  const { accountId, domainId } = useParams();

  const close = (googleAd) => {
    setGoogleAd(googleAd);
    setGuidanceShow(true);
  };

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/google/ads` },
    { title: 'New' },
  ].map((item, index) => (
    <Anchor href={item.href} key={index}>
      {item.title}
    </Anchor>
  ));

  return (
    <>
      <Metadata title={`${page} | New`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <GuidanceModal
        type="Google Ad"
        redirect={`/accounts/${accountId}/domains/${domainId}/google/ads`}
        show={guidanceShow}
        elementTypes={['campaigns', 'workflows']}
        element={googleAd}
        setShow={() => setGuidanceShow(false)}
        newElement={true}
      />
      <GoogleAdNewForm
        onCreate={(googleAd) => {
          close(googleAd);
        }}
        onBack={() => navigate(-1)}
        from={from}
      />
    </>
  );
};

export default GoogleAdsNewPage;
